import React from "react";
import { fastPasDa, fastpassAVP } from "../asset/img";
import { AutoLogoutWarning } from "@egovernments/digit-ui-react-components";

const HeaderContent = ({ applicationFlow }) => {
  return (
    <header className="headerContent">
      <img src={applicationFlow === "DA" ? fastPasDa : fastpassAVP} alt="fastpassAVP" />
      <div className="autoLogoutIcon">
        <AutoLogoutWarning color='#1F4A7C' />
      </div>
    </header>
  );
};

export default HeaderContent;
